// extracted by mini-css-extract-plugin
export default {"form":"PauseSlideContentV22_form-k8a","image":"PauseSlideContentV22_image-J0n","heading":"PauseSlideContentV22_heading-btE","description":"PauseSlideContentV22_description-o2r"};